import React from 'react'
import { PROMO_SCHEDULE_STATUS_LABELS } from '../../api/marketing/promoScheduleConstants'
import './ActiveStatusBadge.sass'

const VARIANT_CLASS_MAP = {
  active: 'ActiveStatusBadge_active',
  inactive: 'ActiveStatusBadge_inactive',
  upcoming: 'ActiveStatusBadge_upcoming',
  recent: 'ActiveStatusBadge_recent',
  archived: 'ActiveStatusBadge_archived',
}

function ActiveStatusBadge({ isActive, variant }) {
  if (variant != null) {
    const variantClass = VARIANT_CLASS_MAP[variant] || VARIANT_CLASS_MAP.archived

    return (
      <span className={`ActiveStatusBadge ${variantClass}`.trim()}>
        {PROMO_SCHEDULE_STATUS_LABELS[variant] || '—'}
      </span>
    )
  }

  const isActiveState = isActive === true
  const binaryVariant = isActiveState ? 'active' : 'inactive'

  return (
    <span className={`ActiveStatusBadge ${VARIANT_CLASS_MAP[binaryVariant]}`.trim()}>
      {isActiveState ? 'Активний' : 'Неактивний'}
    </span>
  )
}

export default ActiveStatusBadge
